(function($) {
    $(function() {

        // CUSTOM NUMBER INPUT CHANGES
        $('.cover__slider').slick({
            slideToShow: 1,
            arrows: false,
            dots: true,
            infinite: true
        });

        // CUSTOM NUMBER INPUT CHANGES
        $('.product-slider').slick({
            slideToShow: 1,
            arrows: false,
            dots: true,
            infinite: false
        });

        // CUSTOM NUMBER INPUT CHANGES
        $('.product-gallery__slider').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
            dots: true,
            infinite: false,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }]
        });

        $('.np-modal-slider__main').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            // adaptiveHeight: true,
            asNavFor: '.np-modal-slider__thumb',
            prevArrow: '.np-modal-slider__content .arrow--left',
            nextArrow: '.np-modal-slider__content .arrow--right'
        });

        $('.np-modal-slider__thumb').slick({
            slidesToShow: 7,
            slidesToScroll: 1,
            asNavFor: '.np-modal-slider__main',
            dots: false,
            arrows: false,
            centerMode: true,
            focusOnSelect: true
        });

        $('.js-show-modal-slider').click(function() {
            var seq = $(this).data('image-seq');
            $('.np-modal-slider__container').toggleClass('is-shown');
            $('.np-modal-slider__main').slick('slickGoTo', seq);
            setTimeout(function(){
                $('.np-modal-slider__main').slick('setPosition');
            },100)
        });

        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                $('.np-modal-slider__container').removeClass('is-shown');
            }
            if (e.key === "ArrowRight") {
                $('.np-modal-slider__main').slick("slickNext");
            }
            if (e.key === "ArrowLeft") {
                $('.np-modal-slider__main').slick("slickPrev");
            }
        });


    });
})(jQuery);
